import { Modal, Text } from "@mantine/core";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import useStyles from "./style";

/**
 * In-browser preview of a provider document — same viewer the staff and client
 * document modules use, so PDFs, images and Office files all render inline.
 */
const ProviderPreviewFileModal = ({ opened, onClose, data }) => {
  const { classes } = useStyles();

  // The viewer picks its renderer off the extension, which lives on the S3 key
  // rather than the (renameable) display name.
  const fileType = data?.fileUrl?.split(".").pop()?.split("?")[0]?.toLowerCase();

  return (
    <Modal
      className={classes.previewModal}
      opened={opened}
      size="xl"
      onClose={onClose}
      shadow="sm"
      overlayProps={{ blur: 3 }}
      radius="md"
      zIndex={1000}
      centered
      title={
        <Text sx={{ fontFamily: "Inter", fontSize: 16, fontWeight: 600 }} title={data?.name}>
          {data?.name}
        </Text>
      }
    >
      {data?.fileUrl && (
        <DocViewer
          style={{ width: "100%", minHeight: 620 }}
          key={data?._id || data?.id}
          documents={[{ uri: data.fileUrl, fileType }]}
          pluginRenderers={DocViewerRenderers}
        />
      )}
    </Modal>
  );
};

export default ProviderPreviewFileModal;
